import { render, staticRenderFns } from "./ThirdPartyInsecticidalLamp.vue?vue&type=template&id=4dcb63a0&scoped=true"
import script from "./ThirdPartyInsecticidalLamp.vue?vue&type=script&lang=js"
export * from "./ThirdPartyInsecticidalLamp.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyInsecticidalLamp.vue?vue&type=style&index=0&id=4dcb63a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb63a0",
  null
  
)

export default component.exports